import { frame } from "assets";
import styled from "styled-components";

export const MainSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;

  @media (max-width: 990px) {
    padding: 2rem 1rem 12rem 1rem;
  }
`;

export const CardWrapper = styled.div`
  position: relative;
  width: 371px;
  height: 553.5px;

  .mask1 {
    -webkit-mask-image: url(${frame});
    mask-image: url(${frame});
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
  }

  @media (max-width: 767px) {
    height: 540.96px;
    width: 100%;
  }

  .innerimg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }

  @media (max-width: 767px) {
    margin-top: 3rem;
  }
`;

export const CardInnerDiv = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  padding: 1.5rem 1.7rem;

  @media (max-width: 990px) {
    padding: 1rem 1rem;
  }

  h1 {
    color: #fff;
    font-size: 24px;
    font-style: italic;
    font-weight: 400;
    line-height: normal;
    margin-top: 1rem;
  }

  .content-div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.7rem;
    h5 {
      color: #8e8c8c;
      font-family: "Inter" !important;
      font-size: 17.444px;
      font-style: italic;
      font-weight: 500;
      line-height: normal;
      margin: 0;
    }

    p {
      text-align: right;
      font-family: "Inter" !important;
      font-size: 17.444px;
      font-style: italic;
      font-weight: 600;
      line-height: normal;
      background: var(
        --yellow,
        linear-gradient(180deg, #e0c528 0%, #f7c13a 100%)
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      margin: 0;
    }
  }
`;

export const RightDiv = styled.div`
  h1 {
    color: var(--f-7-c-13-a, #f7c13a);
    font-size: 48px;
    font-style: italic;
    font-weight: 400;
    line-height: normal;
  }
`;

export const MainWrapper = styled.div`
  display: flex;
  gap: 4rem;
  position: relative;
  padding: 3rem 2rem 0rem 3rem;

  @media (max-width: 990px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0rem 1rem 0rem 1rem;
  }
`;

export const MainDiv = styled.div`
  position: relative;
  width: 1193.928px;
  height: 659.651px;

  @media (max-width: 990px) {
    width: 100%;
    height: 100%;
  }

  .maininnerimg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;

    @media (max-width: 990px) {
      display: none;
    }
  }

  .maininnerimg2 {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;

    @media (min-width: 990px) {
      display: none;
    }
  }
`;

export const FirstDiv = styled.div`
  display: flex;
  gap: 3rem;
  align-items: center;
  margin-top: 2rem;
  h1 {
    color: #f7c13a;
    font-size: 128px;
    font-style: italic;
    font-weight: 400;
    line-height: normal;
  }

  .first-div {
    h1 {
      color: #f7c13a;
      font-size: 24px;
      font-style: italic;
      font-weight: 400;
      line-height: 77.247px; /* 321.862% */
      letter-spacing: -0.48px;
      margin: 0;
    }

    p {
      color: #fff;
      font-family: "Inter";
      font-size: 16px;
      font-style: italic;
      font-weight: 500;
      line-height: 136.8%; /* 21.888px */
      letter-spacing: 0.96px;
      margin-top: 0.5rem;
      margin-bottom: 0rem;
    }
  }
`;

export const SecondDiv = styled.div`
  .second-div {
    display: flex;
    align-items: center;
    margin-top: 0.5rem;
    justify-content: space-between;
    h5 {
      color: #fff;
      font-family: "Inter";
      font-size: 26px;
      font-style: italic;
      font-weight: 400;
      line-height: normal;
      margin: 0;
    }

    p {
      color: #fff;
      font-family: "Inter";
      font-size: 26px;
      font-style: italic;
      font-weight: 400;
      line-height: normal;
      margin: 0;
      text-align: end;
    }
  }

  .total-div {
    display: flex;
    align-items: center;
    margin-top: 0.4rem;
    justify-content: space-between;
    h5 {
      color: #f7c13a;
      font-family: "Inter";
      font-size: 26px;
      font-style: italic;
      font-weight: 700;
      line-height: normal;
      margin: 0;
    }

    p {
      color: #f7c13a;
      font-family: "Inter";
      font-size: 26px;
      font-style: italic;
      font-weight: 700;
      line-height: normal;
      margin: 0;
    }
  }
`;

export const BtnDiv = styled.div`
  .register-btn-div {
    cursor: pointer;
    position: relative;
    width: 215px;
    height: 46px;
    margin-top: 3rem;
    display: block;
    margin-left: auto;
    margin-right: auto;
    h1 {
      font-size: 16px;
      font-style: italic;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: 0em;
      color: #331d01;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      width: 100%;
    }

    .btn-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`;

export const MintWrapper = styled.div`
  margin-left: 8rem;
  width: 28rem;
`;

export const SuccessDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-top: 2rem;
  h1 {
    color: #f7c13a;
    font-size: 40px;
    font-style: italic;
    font-weight: 400;
    line-height: 116.755px; /* 291.887% */
    letter-spacing: -0.8px;
  }
`;

export const MessageDiv = styled.div`
  h5 {
    color: #fff;
    font-family: "Inter";
    font-size: 16px;
    font-style: italic;
    font-weight: 700;
    line-height: 136.8%; /* 21.888px */
    letter-spacing: 0.96px;
    margin-top: 1.5rem;
  }

  p {
    color: #fff;
    font-family: "Inter";
    font-size: 16px;
    font-style: italic;
    font-weight: 500;
    line-height: 136.8%;
    letter-spacing: 0.96px;
    margin-top: 1.5rem;
  }
`;

export const ImgDiv = styled.div`
  margin-top: 3.5rem;
  display: flex;
  gap: 2.5rem;
`;

export const TopTitle = styled.h1`
  font-size: 48px;
  font-style: italic;
  font-weight: 400;
  line-height: 57px;
  letter-spacing: 0em;
  text-align: left;

  @media (max-width: 990px) {
    font-size: 24px !important;
    text-align: center;
    margin-top: -2.5rem;
  }
`;

export const TabsWrapper = styled.div`
  width: 378px;
  height: 52px;
  display: flex;
  gap: 10px;
  background-color: rgba(178, 171, 171, 0.1);
  backdrop-filter: blur(16.399999618530273px);
  border: 1px solid rgba(82, 82, 83, 1);
  justify-content: space-between;
  align-items: center;
  border-radius: 10px;
  padding: 0rem 0.5rem;

  @media (max-width: 767px) {
    width: 100%;
    margin-top: 2rem;
  }

  div {
    flex: 1;
    display: flex;
    height: 37px;
    justify-content: center;
    align-items: center;
  }
  h5 {
    font-family: "Inter";
    font-size: 14px;
    font-style: italic;
    font-weight: 700;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: left;
    color: rgba(82, 82, 83, 1);
    margin-bottom: 0rem;
    cursor: pointer;

    @media (max-width: 767px) {
      font-size: 10px;
    }
  }

  .tab-active {
    border-radius: 5px;
    background: rgba(247, 193, 58, 1);
    cursor: pointer;

    h5 {
      color: rgba(51, 29, 1, 1) !important;
    }
  }

  .non-active {
    &:hover {
      border-radius: 11px;
      background: #323232;
      cursor: not-allowed;

      h5 {
        cursor: not-allowed;
      }
    }
  }
`;

export const ContentDiv = styled.div`
  margin-top: 1.5rem;
`;

export const TextContent = styled.div`
  h5 {
    font-family: "Inter";
    font-size: 24px;
    font-style: italic;
    font-weight: 600;
    line-height: 50px;
    letter-spacing: 0em;
    text-align: left;
    color: rgba(255, 255, 255, 1);
    margin-bottom: 0rem;
    span {
      color: rgba(247, 193, 58, 1);
      font-weight: 700;
    }

    @media (max-width: 990px) {
      font-size: 16px;
      line-height: 30px;
    }
  }
`;

export const BtnDiv1 = styled.div`
  .register-btn-div {
    cursor: pointer;
    position: relative;
    width: 316.11px;
    height: 51.88px;
    margin-top: 3rem;

    @media (max-width: 990px) {
      width: 214.114px;
      height: 35.143px;
      margin-top: 1.5rem;
      margin-bottom: 2rem;
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
    h1 {
      font-size: 24px;
      font-style: italic;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: 0em;
      color: rgba(51, 29, 1, 1);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      width: 100%;
      @media (max-width: 990px) {
        font-size: 16px;
      }
    }

    .btn-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`;

export const QuestionDiv = styled.div`
  p {
    font-family: "Inter";
    font-size: 24px;
    font-style: italic;
    font-weight: 600;
    line-height: 50px;
    letter-spacing: 0em;
    text-align: left;
    color: rgba(247, 193, 58, 1);

    @media (max-width: 990px) {
      font-size: 16px;
    }
    line-height: 25px;
  }
  .register-btn-div {
    cursor: pointer;
    position: relative;
    width: 233.5px;
    height: 51.88px;

    h1 {
      font-size: 24px;
      font-style: italic;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: 0em;
      color: rgba(51, 29, 1, 1);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      width: 100%;
    }

    h5 {
      font-family: "Space Crusaders" !important ;
      font-size: 24px;
      font-style: italic;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: 0em;
      color: rgba(247, 193, 58, 1);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      width: 100%;
    }

    .btn-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .btn-wrapper {
    display: flex;
    align-items: center;
    gap: 2rem;

    @media (max-width: 990px) {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      padding-bottom: 2rem;
    }
  }
`;

export const DoneDiv = styled.div`
  margin-top: 2rem;
  h1 {
    font-size: 48px;
    font-style: italic;
    font-weight: 400;
    line-height: 57px;
    letter-spacing: 0em;
    text-align: left;
  }
`;
